import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logos/DBHubsTextLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-4c87051f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { id: "logo-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  id: "logo-text"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  ref: "dropdown"
}
const _hoisted_5 = { class: "navbar" }
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass(['link-container-wrapper'])
}
const _hoisted_8 = { class: "link-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, "|", -1))
const _hoisted_10 = { class: "link-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, "|", -1))
const _hoisted_12 = { class: "link-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, "|", -1))
const _hoisted_14 = { class: "link-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, "|", -1))
const _hoisted_16 = { class: "link-container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(_ctx.isMenuOpen ? 'nav-dropdown-enabled__container' : '')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        id: "menuToggle",
        class: "menu-toggle",
        onClick: _cache[0] || (_cache[0] = () => _ctx.toggleMenu())
      }, " ☰ "),
      (_ctx.isMenuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_Transition, { name: "dropdown" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("ul", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      onClick: _cache[1] || (_cache[1] = () => _ctx.toggleMenu()),
                      class: "nav-link hover-color-nav",
                      draggable: "false",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Home")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      onClick: _cache[2] || (_cache[2] = () => _ctx.toggleMenu()),
                      class: "nav-link hover-color-nav",
                      draggable: "false",
                      to: "/coaches"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Coaches")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      onClick: _cache[3] || (_cache[3] = () => _ctx.toggleMenu()),
                      class: "nav-link hover-color-nav",
                      draggable: "false",
                      to: "/about"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("About")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      onClick: _cache[4] || (_cache[4] = () => _ctx.toggleMenu()),
                      class: "nav-link hover-color-nav",
                      draggable: "false",
                      to: "/testimonials"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Testimonials")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      onClick: _cache[5] || (_cache[5] = () => _ctx.toggleMenu()),
                      class: "nav-link hover-color-nav",
                      draggable: "false",
                      to: "/join"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Join")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ], 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: "nav-link hover-color-nav",
            draggable: "false",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          })
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            class: "nav-link hover-color-nav",
            draggable: "false",
            to: "/coaches"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Coaches")
            ]),
            _: 1
          })
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, {
            class: "nav-link hover-color-nav",
            draggable: "false",
            to: "/about"
          }, {
            default: _withCtx(() => [
              _createTextVNode("About")
            ]),
            _: 1
          })
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, {
            class: "nav-link hover-color-nav",
            draggable: "false",
            to: "/testimonials"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Testimonials")
            ]),
            _: 1
          })
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_router_link, {
            class: "nav-link hover-color-nav",
            draggable: "false",
            to: "/join"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Join")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_17
    ], 2),
    _createVNode(_component_router_view)
  ]))
}